<template>
  <vs-popup
    v-if="this.notifications.length != 0"
    title="Notificações"
    :active.sync="openPopUp"
    class="notification-popup"
  >
    <vs-row>
      <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="2">
        <vs-button
          radius
          color="primary"
          type="flat"
          icon="chevron_left"
          class="button-prev"
        />
      </vs-col>

      <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="8">
        <vx-card class="overflow-hidden">
          <template slot="no-body">
            <swiper
              ref="MySwiper"
              class="swiper"
              :options="swiperOption"
              @slideChange="changeSlideForButton"
              style="min-height: 70vh;"
            >
              <swiper-slide
                v-for="(notification, index) in notifications"
                :key="`notification-${index}`"
              >
                <h1 class="h4 p-3 text-center text-header">{{ notification.title }}</h1>
                <p class="h7 p-3 text-body" v-html="notification.text.trim()"/>
                <iframe
                  v-if="notification.video_url && openPopUp"
                  width="100%" 
                  height="300"
                  :src="notification.video_url"
                  frameborder="0"
                  class="pb-10"
                  ref="ytPlayer"
                  allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" 
                  allowfullscreen
                />
              </swiper-slide>
              <div class="swiper-pagination" slot="pagination"></div>
            </swiper>
          </template>
        </vx-card>
      </vs-col>

      <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="2">
        <vs-button
          radius
          color="primary"
          type="flat"
          icon="chevron_right"
          class="button-next"
        />
      </vs-col>

      <vs-col vs-type="flex" vs-justify="center" vs-align="center">
        <vs-button
          style="margin-top: 3%"
          class="button-next"
          :style="{ display: displayContinue }"
          >Continuar</vs-button
        >
        <vs-button
          style="margin-top: 3%"
          :style="{ display: displayMarkAsFinished }"
          @click="readAllNotifications"
          >Marcar como lida(s)</vs-button
        >
      </vs-col>
    </vs-row>

    <vs-row>
      <vs-col
        vs-type="flex"
        vs-justify="center"
        vs-align="center"
        vs-w="12"
        class="mt-8"
      >
      </vs-col>
    </vs-row>
  </vs-popup>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import userNotification from "@/http/requests/userNotification";
import moduleUserNotification from "@/store/userNotification/moduleUserNotification.js";

export default {
  data() {
    return {
      openPopUp: true,
      numberOfNotifications: 0,
      notifications: "",
      displayContinue: "",
      displayMarkAsFinished: "none",
      swiperOption: {
        pagination: {
          el: ".swiper-pagination",
          type: "bullets",
          clickable: true,
        },
        navigation: {
          nextEl: ".button-next",
          prevEl: ".button-prev",
        },
      },
    };
  },
  components: {
    swiper,
    swiperSlide,
  },
  methods: {
    changeSlideForButton() {
      if (
        this.$refs.MySwiper.swiper.activeIndex <
        this.notifications.length - 1
      ) {
        this.displayContinue = "";
        this.displayMarkAsFinished = "none";
      } else {
        this.displayContinue = "none";
        this.displayMarkAsFinished = "";
      }
    },
    async readAllNotifications() {
      try {
        /* for (let i = 0; i < this.notifications.length; i++) {
          await userNotification.read(this.notifications[i]["id"]);
        } */
        this.openPopUp = false;
        for (let i = 0; i < this.notifications.length; i++) {
          this.$store.dispatch("setShowLoadingOverlay", false);
          await this.$store.dispatch("userNotificationStore/read",this.notifications[i]["id"]);
        }
        this.$vs.notify({
          title: "Sucesso",
          text: "Todas as notificações foram lidas",
          color: "success",
        });
        return true;
      } catch (Exception) {
        this.$vs.notify({
          title: "Erro inesperado",
          text: "Ocorreu um erro inesperado, peço que contate nossa equipe",
          color: "danger",
        });
        this.openPopUp = false;
        return false;
      }
    },
  },
  async created()
  {
      if (!moduleUserNotification.isRegistered) {
      await this.$store.registerModule('userNotificationStore', moduleUserNotification)
      moduleUserNotification.isRegistered = true
    }
  },
  async mounted() {
    let id = this.$store.state.AppActiveUser["id"];
    let userNotificationRaw = await userNotification.fetch(id);
    this.notifications =
      userNotificationRaw["data"]["data"]["userNotifications"];
    if (this.notifications.length == 1) {
      this.displayContinue = "none";
      this.displayMarkAsFinished = "";
    }
  },
};
</script>

<style lang="scss">
.notification-popup {
  .text-header {
    color: $PRIMARY_COLOR;
  }

  .text-body {
    padding: 1rem;
    -webkit-transition: all .23s ease .1s;
    transition: all .23s ease .1s;
    white-space: pre-line;
    font-size: 1rem;
    img {
      max-width: 100% !important;
    }
  }

  .swiper {
    height: 420px;
  }

  .swiper-container {
    position: relative;
    overflow: hidden;
    list-style: none;
    z-index: 1;
  }

  .swiper-wrapper {
    position: relative !important;
    width: 100% !important;
    height: 100% !important;
    z-index: 1 !important;
    display: flex !important;
    box-sizing: content-box !important;
  }

  .swiper-slide {
    flex-shrink: 0;
    width: 100%;
    height: 100%;
    position: relative;
  }

  .swiper-pagination-fraction,
  .swiper-pagination-custom,
  .swiper-container-horizontal > .swiper-pagination-bullets {
    bottom: 10px;
    width: 100%;
  }

  .swiper-pagination {
    position: absolute;
    transition: 300ms opacity;
    z-index: 10;
    text-align: center;
  }

  .swiper-pagination-bullet {
    width: 8px;
    height: 8px;
    display: inline-block;
    border-radius: 50%;
    background: #000;
    margin: 0 4px;
    cursor: pointer;
    opacity: 0.2;
  }

  .swiper-pagination-bullet-active {
    opacity: 1;
  }

  .swiper-slide-active {
    overflow: auto;
  }

  [dir]
    .swiper-container-horizontal
    > .swiper-pagination-bullets
    .swiper-pagination-bullet {
    margin: 0 4px;
  }
}
</style>
